import { Navigate, Route, Routes } from 'react-router-dom';
import PlatformLayout from '../components/PlatformLayout';
import PlatformLanding from '../pages/Platform/Landing/PlatformLanding';
import PlatformLogin from '../pages/Platform/Login/PlatformLogin';
import TenantList from '../pages/Platform/Tenants/TenantList';
import TenantCreate from '../pages/Platform/Tenants/TenantCreate';
import { usePlatformAuth } from '../utils/PlatformAuthContext';

const PrivateRoute = ({ children }) => {
  const { estaAutenticado } = usePlatformAuth();
  return estaAutenticado ? children : <Navigate to="/login" replace />;
};

const PlatformRoutes = () => (
  <Routes>
    <Route path="/" element={<PlatformLanding />} />
    <Route path="/login" element={<PlatformLogin />} />
    <Route
      element={
        <PrivateRoute>
          <PlatformLayout />
        </PrivateRoute>
      }
    >
      <Route path="/tenants" element={<TenantList />} />
      <Route path="/tenants/new" element={<TenantCreate />} />
    </Route>
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default PlatformRoutes;
